/** Parses MM-DD-YYYY, YYYY-MM-DD, ISO, or Date into a local Date. */
export const parseFormDateValue = (
  value?: string | Date | null
): Date | null => {
  if (!value) return null;
  if (value instanceof Date && !isNaN(value.getTime())) return value;
  if (typeof value === 'string') {
    const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      const parsed = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    const mdy = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (mdy) {
      const parsed = new Date(Number(mdy[3]), Number(mdy[1]) - 1, Number(mdy[2]));
      return isNaN(parsed.getTime()) ? null : parsed;
    }
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

export const formatFormDateValue = (date: Date): string => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};
